// extracted by mini-css-extract-plugin
export default {"md":"Readme_md__W7iI7","btnLink":"Readme_btnLink__X3MLU","paragraph":"Readme_paragraph__xOA6Q","quote":"Readme_quote__s3rZs"};